import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default from 'react';
import classNames from 'classnames';
import styles from './63839ce6db15aab38b5980af582e7d1af75ab7800c8a2bfb6ae2cef4bba969b5.cfe-internal.js';
import { useFormFieldLabel } from '../FormField/f390dafefe74ba07f7da711a77443b7b51d96a6ad1aee47361fd1804064e9ba7.cfe-internal.js';

var _excluded = ["children", "className"];
var Label = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useFormFieldLabel = useFormFieldLabel(),
    isFocused = _useFormFieldLabel.isFocused,
    hasControl = _useFormFieldLabel.hasControl;
  var classes = classNames(styles.label, className, _defineProperty(_defineProperty({}, styles.control, hasControl), styles.focused, isFocused));
  return /*#__PURE__*/React__default.createElement("label", _extends({}, rest, {
    ref: ref,
    className: classes
  }), children);
});

export { Label as default };
